import { ScreenScanPage } from '@hq/screen-scan';
import { hq } from '../api/client';

/**
 * 申请码确认（PC 端，HOSPITAL 门户）：
 * 输入大屏上显示的 12 位申请码（4-4-4 三段），当前登录账号直接确认；
 * 授权范围固定为本机构（含分院），由后端按令牌决定。
 */
export default function ScreenScan() {
  return <ScreenScanPage hq={hq} />;
}
